module.exports = __webpack_public_path__ + "static/img/h-first.09414766.png";